export default {
  appDownloadURL_Android: 'https://play.google.com/store/apps/details?id=com.antwallet.giftcard',
  appDownloadURL_iOS: 'https://apps.apple.com/us/app/migo/id6670494373',
  appDownloadURL_Web: 'https://web.migogiftcard.com/#login',
  Telegram: 'https://wwww.baidu.com',
  Twitter: 'https://wwww.baidu.com',
  Instagram: 'https://wwww.baidu.com',
  Login: 'https://web.migogiftcard.com/#login',
  Register: 'https://web.migogiftcard.com/#login',
}